// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentRefPage_root__1eoot","title":"PaymentRefPage_title__1Oo-5"};